import { useLocale } from '../i18n/LocaleProvider'
import { CurrencyJpy, ChartLineUp, Translate, UsersThree, Robot } from '@phosphor-icons/react'
import type { Icon } from '@phosphor-icons/react'
import './WhyJapanSection.css'

const stats = [
  { num: '¥1.4T', label: 'Japan SaaS market (2023)', sub: 'Growing to ¥2T+ by 2027 at 11% CAGR' },
  { num: '¥101.6B', label: 'Japan GenAI market in 2024', sub: 'Projected to exceed ¥1 trillion by ~2030' },
  { num: '27%', label: 'Japanese enterprise GenAI adoption', sub: 'vs. 68.8% in the US and 81.2% in China' },
]

const reasons: { icon: Icon; title: string; body: string }[] = [
  {
    icon: CurrencyJpy,
    title: 'Established Willingness to Pay',
    body: 'Japanese enterprises routinely pay tens to hundreds of thousands of yen per month per software subscription.',
  },
  {
    icon: ChartLineUp,
    title: 'Adoption Gap = Open Market',
    body: '46.2% of Japanese firms are actively evaluating AI adoption, but only 27% have implemented it. First-mover advantage is massive.',
  },
  {
    icon: Translate,
    title: 'Language Barrier Is a Moat',
    body: 'Domestic LLM projects (NTT\'s "tsuzumi", NEC\'s "cotomi") exist precisely because overseas AI cannot operate in Japanese out-of-the-box.',
  },
  {
    icon: UsersThree,
    title: 'Sales Talent Is the Bottleneck',
    body: '~60% of foreign-affiliated companies in Japan cite sales & marketing as their hardest role to fill. We solve this for you.',
  },
  {
    icon: Robot,
    title: 'AI Adoption Value Gap',
    body: 'Japanese enterprises report low ROI despite adoption — creating enormous demand for knowledgeable implementation partners. (PwC Japan 2025)',
  },
]

export default function WhyJapanSection() {
  const { t } = useLocale()
  return (
    <section className="whyjapan-section">
      <div className="container">
        <div className="section-header">
          <span className="section-jp">{t("The opportunity in Japan")}</span>
          <h2>{t('Why Japan, and why now?')}</h2>
        </div>

        {/* Stats row */}
        <div className="wj-stats">
          {stats.map((s) => (
            <div className="wj-stat" key={s.num}>
              <div className="stat-num">
                {t(s.num)}
              </div>
              <div className="wj-stat-label">{t(s.label)}</div>
              <div className="wj-stat-sub">{t(s.sub)}</div>
            </div>
          ))}
        </div>

        {/* Reasons */}
        <div className="wj-reasons">
          {reasons.map((r) => (
            <div className="wj-reason" key={r.title}>
              <span className="wj-reason-icon">
                <r.icon size={20} weight="bold" />
              </span>
              <div>
                <h3>{t(r.title)}</h3>
                <p>{t(r.body)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
